/* eslint-disable default-param-last */
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';

import { makeT, localeNumberFormat } from './locales';
import {
  LOCATION_CHANGE,
  LOCATION_MODAL_TOGGLE,
  CHANGE_USER_LOCATION,
  SET_PB_LINK_META,
  CROSSING_LOCALE_BANNER_CLOSE,
} from '../Actions';
import { setLocaleCookie } from '../PageBuilder/helpers/cookies';

const EN_US = { code: 'en-US' };
const DEFAULT = { locale: EN_US, availableLocales: [EN_US] };

export const locationReducer = (state, action) => {
  const newState = _.cloneDeep(_.assign({}, DEFAULT, state));

  switch (action.type) {
    case LOCATION_CHANGE: {
      const { zip, locale, address } = action.location;
      return _.assign({}, newState, { zip, locale, address });
    }
    case LOCATION_MODAL_TOGGLE: {
      const { locationModalOpen } = action;
      return _.assign({}, newState, { locationModalOpen });
    }
    case CHANGE_USER_LOCATION: {
      // for when user accepts a locale
      // change both userLocale and locale
      setLocaleCookie(action.location?.locale?.code);
      return _.assign({}, newState, {
        userLocale: action.location.locale,
        zip: action.location.zip,
        locale: action.location.locale,
        address: action.location.address,
      });
    }
    case CROSSING_LOCALE_BANNER_CLOSE: {
      return _.assign({}, newState, { hasUserClosedCrossingLocaleBanner: true });
    }
    case SET_PB_LINK_META: {
      const { PB_LINK_META } = newState;
      PB_LINK_META[action.url] = action.value;
      return _.assign({}, newState, { PB_LINK_META });
    }
    default:
      return newState;
  }
};

export const changeLocation = location => ({ type: LOCATION_CHANGE, location });
export const openLocationModal = () => ({
  type: LOCATION_MODAL_TOGGLE,
  locationModalOpen: true,
});
export const closeLocationModal = () => ({
  type: LOCATION_MODAL_TOGGLE,
  locationModalOpen: false,
});
export const changeUserLocation = location => ({
  type: CHANGE_USER_LOCATION,
  location,
});
export const closeCrossingLocaleBanner = () => ({ type: CROSSING_LOCALE_BANNER_CLOSE });
export const setLinkMeta = (url, value) => ({
  type: SET_PB_LINK_META,
  url,
  value,
});
export const useLocaleCode = () => useSelector(state => state.location?.locale?.code) || 'en-US';

// memoize these else every component re-renders on any touching of the redux store
const memT = _.memoize(makeT);
const memNumberFormat = _.memoize(localeNumberFormat);
export const connectLocation = connect(
  state => ({
    ...state.location,
    // the warranty forms run on their own stores, which carry no location slice;
    // react-localization throws on an undefined language, so fall back rather than pass it through
    t: memT(state.location?.locale?.code || 'en-US'),
    tNumber: memNumberFormat(state.location?.locale?.code || 'en-US'),
  }),
  {
    changeLocation,
    openLocationModal,
    closeLocationModal,
    changeUserLocation,
    closeCrossingLocaleBanner,
    setLinkMeta,
  },
  null,
  { forwardRef: true }
);
